import { render, staticRenderFns } from "./FacultyDirectory.vue?vue&type=template&id=20d386c6"
import script from "./FacultyDirectory.vue?vue&type=script&lang=js"
export * from "./FacultyDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d386c6')) {
      api.createRecord('20d386c6', component.options)
    } else {
      api.reload('20d386c6', component.options)
    }
    module.hot.accept("./FacultyDirectory.vue?vue&type=template&id=20d386c6", function () {
      api.rerender('20d386c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/FacultyDirectory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FacultyDirectory.vue
// module id = 392
// module chunks = 0